import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatToZMW, rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import { useOutletContext } from "react-router-dom";

export default function TrialBalance({rdata}) {
  const [trialBalanceData, setTrialBalanceData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const auth = useAuth();
  
  
  const allData = useOutletContext();

  const fetchData = async () => {
      processTrialBalanceData(rdata);
  };

  const processTrialBalanceData = (response) => {
    const trialData = [];
    let totalDebits = 0;
    let totalCredits = 0;

    const totalBills = sumArray(response.bills.map((res) => parseFloat(res.amount)));
    const totalCred = sumArray(response.supplier.filter((a) => a.type == 1).map((res) => parseFloat(res.amount)));

    response.bills.forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa_id);
      const debit = 0;
      const credit = parseFloat(res.amount);
      trialData.push({ code: coa.coa, desc: allData.coa?.find(item => item.account === coa.coa)?.name, debit, credit });
      totalCredits += credit;
    });

    

    response.supplier.filter((a) => a.type == 1).forEach((res) => {
        const coa = allData.budget?.find(item => item.id === res.coa);
    //   const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === res.coa).map((r) => parseFloat(r.amount)));
    //   const toCoa = sumArray(response.journal.filter((a) => a.to_coa === res.coa).map((r) => parseFloat(r.amount)));
    //   const debit = parseFloat(res.amount) - fromCoa + toCoa;
      const debit = parseFloat(res.amount);
      const credit = 0;
      trialData.push({ code: coa.coa, desc: allData.coa?.find(item => item.account === coa.coa)?.name, debit, credit });
      totalDebits += debit;
    });



    trialData.push({
      code: 321030,
      desc: "Debtors Control Account",
      debit: totalBills - response.recs[0]?.amount || 0,
      credit: 0,
    });
    totalDebits += totalBills - response.recs[0]?.amount || 0;

    trialData.push({
      code: 326060,
      desc: "Cash",
      debit: parseFloat(response.cash[0]?.difference) || 0,
      credit: 0,
    });
    totalDebits += parseFloat(response.cash[0]?.difference) || 0;

    trialData.push({
      code: 41110,
      desc: "Creditors Control Account",
      debit: 0,
      credit: totalCred - sumArray(response.supplier.filter((a) => a.type == 2).map((res) => parseFloat(res.amount))),
    });
    totalCredits += totalCred - sumArray(response.supplier.filter((a) => a.type == 2).map((res) => parseFloat(res.amount)));

    setTrialBalanceData(trialData);
    setTotalDebit(totalDebits);
    setTotalCredit(totalCredits);
  };

  const sumArray = (arr) => arr.reduce((sum, num) => sum + num, 0);


  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <h1 className="font-bold text-2xl my-3">Trial Balance</h1>
      <div className="flex items-center justify-between border-b pb-4">
     
       
      </div>
      <table className="table-auto w-full mt-4 border-collapse border border-gray-300 shadow-lg rounded-lg">
  <thead className="bg-blue-900 text-white text-left p-2">
    <tr className="p-2">
      <th className="px-4 py-2 border-b border-gray-300">Code</th>
      <th className="px-4 py-2 border-b border-gray-300">Description</th>
      <th className="px-4 py-2 border-b border-gray-300 text-right">Debit</th>
      <th className="px-4 py-2 border-b border-gray-300 text-right">Credit</th>
    </tr>
  </thead>
  <tbody>
    {trialBalanceData.map((entry, index) => (
      <tr
        key={index}
        className={`text-gray-700 hover:bg-gray-100 ${
          index % 2 === 0 ? "bg-gray-50" : "bg-white"
        }`}
      >
        <td className="px-4 py-3 border-b border-gray-300">{entry.code}</td>
        <td className="px-4 py-3 border-b border-gray-300">{entry.desc}</td>
        <td className="px-4 py-3 border-b border-gray-300 text-right">
          {formatToZMW(entry.debit.toFixed(2))}
        </td>
        <td className="px-4 py-3 border-b border-gray-300 text-right">
          {formatToZMW(entry.credit.toFixed(2))}
        </td>
      </tr>
    ))}
  </tbody>
  <tfoot>
    <tr className="text-gray-800 font-semibold bg-gray-200">
      <th colSpan="2" className="px-4 py-3 text-left border-t border-gray-300">
        Total
      </th>
      <th className="px-4 py-3 text-right border-t border-gray-300">
        {formatToZMW(totalDebit.toFixed(2))}
      </th>
      <th className="px-4 py-3 text-right border-t border-gray-300">
        {formatToZMW(totalCredit.toFixed(2))}
      </th>
    </tr>
  </tfoot>
</table>

      <div className={`mt-4 ${totalDebit === totalCredit ? "text-green-500" : "text-red-500"}`}>
        Trial Balance is {totalDebit === totalCredit ? "Balanced" : "Not Balanced"}
      </div>
    </div>
  );
}
